// --------------------------------------------------------------------------
// #94 – Cookie Policy
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var cookie = require('common-js-cookie');

module.exports = function (options) {
    var context = options.context;
    var currentDomain = document.domain;

    function init() {

        function checkForCookie() {
            return cookie.getItem('cookiesAccepted') === 'yes';
        }

        function setCookie() {
            cookie.setItem('cookiesAccepted', 'yes', 'Fri, 31 Dec 9999 23:59:59 GMT', '/', currentDomain);
        }

        function hideCookieBanner() {
            $(context).removeClass('cookie-banner').addClass('cookie-banner--hide');
        }

        if (checkForCookie()) {
            hideCookieBanner();
        }

        $(context).find('.button').on('click', function (e) {
            e.preventDefault();
            setCookie();
            hideCookieBanner();
        });
    }

    if (currentDomain.indexOf('ww') === 0) {
        currentDomain = currentDomain.substr(3);
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/cookie-banner.js
// module id = 177
// module chunks = 0